export default __webpack_public_path__ + "static/media/five.9b09e258.jpg";